import { configurationSettings } from '../../../../configuration/configuration-settings';
import { TicketingMode } from '../../../../configuration/types/order/ticketing-mode';
import { getShowtimeById } from './get-showtime-by-id';
export const isSeatFirstOrderingForShowtime = (showtimeId) => {
    if (configurationSettings.data.order.ticketingMode === TicketingMode.TicketFirst)
        return false;
    const showtime = getShowtimeById(showtimeId);
    if (!showtime)
        throw new Error(`Cannot find showtime with ID '${showtimeId}'.`);
    return showtime.isAllocatedSeating;
};
